// extracted by mini-css-extract-plugin
export default {"banner":"index_banner__2PPh0"};